export default "__VITE_ASSET__Dl16MCSS__"